import { useEffect, useState } from 'react';
import { Box, Paper, IconButton, InputBase, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useParams } from 'react-router-dom';
import { getCustomerDocs } from 'service/CustomerService';
import DocumentList from 'components/documentList/DocumentList';
import { GridSearchIcon } from '@mui/x-data-grid';
import { strings } from 'i18n/Strings';

export interface DocumentData {
  id: number;
  userId: number;
  documentName: string;
  createdAt: string;
  updatedAt: string;
  DocumentImage?: {
    documentImageId: number;
    userId: number;
    userDocumentId: number;
    image: string;
    fileName: string;
    type: string;
    size: string;
    key: string;
    category: string | null;
    uploadDate: string;
    createdAt: string;
    updatedAt: string;
  };
}

const useStyles = makeStyles({
  paper: {
    width: '100%',
    padding: '10px',
  },
  emptyPensionContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '70vh',
    width: '100%',
  },
  emptyPensionText: {
    fontFamily: 'Inter!important',
    color: '#838383',
    fontWeight: 500,
    fontSize: '1.125rem',
    lineHeight: 1.2,
  },
});

const Documents = (): JSX.Element => {
  const classes = useStyles();
  const { id } = useParams();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [docList, setDocList] = useState<any[]>([]);
  const [search, setSearch] = useState<string>('');
  useEffect(() => {
    if (id)
      void getCustomerDocs(id)
        .then((res) => {
          if (res) {
            const { userDocs } = res as { userDocs: DocumentData[] };
            const documentData = userDocs.map((d: DocumentData) => {
              const data = {
                ...d,
                ...d.DocumentImage,
                fileName: d?.DocumentImage?.fileName ?? 'Untitled',
              };
              delete data.DocumentImage;
              return data;
            });
            setDocList(documentData);
          }
        })
        .catch((err) => {
          console.log('Error viewing documents:', err);
        });
  }, [id]);

  return (
    <Box>
      <Paper className={classes.paper}>
        <Grid container spacing={0}>
          <Grid item xs={7} />
          <Grid item xs={5}>
            <Box
              display="flex"
              bgcolor={'#fff'}
              borderRadius={'3px'}
              marginRight={3}
            >
              <InputBase
                sx={{ ml: 2, flex: 1, width: '350px' }}
                placeholder={strings.displayText.searchLabel12}
                onChange={(e: unknown) => {
                  setSearch(e.target.value);
                }}
              />

              <IconButton type="button" sx={{ p: 1 }}>
                <GridSearchIcon />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
        {
          <DocumentList
            documents={
              docList.filter((doc) =>
                doc.fileName?.toLowerCase().includes(search.toLowerCase()),
              ) ?? []
            }
          />
        }
      </Paper>
    </Box>
  );
};

export default Documents;
